export const getWindow = () => window;